import { dataProps, paymentTermListProps } from './properties'

export const setVendorMasterList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}  

export const setVendorMasterData = (state, payload) => {
    state.props = payload.response
    state.statement.list = []
    if(payload.copy) {
        state.props.payment_term_list.forEach(element => {
            element.id = 0
        })
    }

    let key = 0
    state.props.payment_term_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const addNewVendorMasterPaymentTermRow = state => {

    let key = 0
    state.props.payment_term_list.push(JSON.parse(JSON.stringify(paymentTermListProps)))

    state.props.payment_term_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('day_count_'+(key-1)).focus()
    }, 300);

}

export const removeVendorMasterPaymentTermRow = (state, payload) => {

    let key = 0

    state.props.payment_term_list.splice(payload, 1)

    if(state.props.payment_term_list.length === 0) {
        state.props.payment_term_list = [JSON.parse(JSON.stringify(paymentTermListProps))]
    }

    state.props.payment_term_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetVendorMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const setVendorMasterStatementList = (state, payload) => {
    state.statement.list = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorMaster/mutations.js